class WholesaleOrderTable extends HTMLElement {
  constructor() {
    super();
    this.countTarget = this.querySelector('[data-order-count]');
    this.subtotalTarget = this.querySelector('[data-order-subtotal]');
    this.addEventListener('change', this.onChange.bind(this));
    this.recalculate();
  }

  onChange(event) {
    const input = event.target;
    if (input.type !== 'number') return;

    const row = input.closest('tr[data-unit-price]');
    if (row) this.updateRowTotal(row, input);

    this.recalculate();
  }

  updateRowTotal(row, input) {
    const target = row.querySelector('[data-row-total-value]');
    if (!target) return;
    const unitPrice = parseInt(row.dataset.unitPrice, 10) || 0;
    const qty = parseInt(input.value, 10) || 0;
    target.textContent = this.formatMoney(unitPrice * qty);
  }

  recalculate() {
    let count = 0;
    let subtotal = 0;

    this.querySelectorAll('tr[data-unit-price]').forEach((row) => {
      const input = row.querySelector('input[type="number"]');
      if (!input) return;
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0) count += 1;
      subtotal += (parseInt(row.dataset.unitPrice, 10) || 0) * qty;
    });

    if (this.countTarget) this.countTarget.textContent = count;
    if (this.subtotalTarget) this.subtotalTarget.textContent = this.formatMoney(subtotal);
  }

  formatMoney(cents) {
    const format = this.dataset.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }
}

customElements.define('wholesale-order-table', WholesaleOrderTable);
